import React from "react";
import ProfileHeader from "./components/ProfileHeader";
import ProfileSection from "./components/ProfileSection";
import PasswordChange from "./components/PasswordChange";
import { useMediaQuery } from "react-responsive";
import NotificationPage from "./components/NotificationPage";
import { Tab, Tabs } from "react-materialize";
import { useSelector } from "react-redux";
import MaterialClassification from "./components/MaterialClassification";

function ProfileDetails() {
  const isLaptop = useMediaQuery({ query: "(max-width:1300px)" });
  const { profile } = useSelector((state) => state.profileStore);
  const { accountType } = useSelector((state) => state.account);
  const { organization, loadings } = useSelector(
    (pre) => pre?.organizationDetails
  );


  return (
    <div className={`${isLaptop ? "" : "container"}`}>
      <ProfileHeader
        organizationData={organization}
        loadings={loadings}
        profile={profile}
      />

      <Tabs>
        <Tab title="General">
          <ProfileSection
            organizationData={organization}
            loadings={loadings}
          />
        </Tab>

        {/* <Tab title="Change Password">
          <PasswordChange />
        </Tab>

        <Tab title="Notification Settings">
          <NotificationPage />
        </Tab> */}
        {accountType === "trader/aggregator" ? (
          <Tab title="Classification">
            <MaterialClassification />
          </Tab>
        ) : (
          <></>
        )}
      </Tabs>
    </div>
  );
}

export default ProfileDetails;
